import shop from "shop/shop"

const checkCartSize = () => {
  if (shop.cart.size === 0) {
    // browserHistory.push("/checkout")
    // shop.toast("Sie haben keine Produkte im Warenkorb")
    return false
  }
  return true
}

const checkMinCartValue = async (value = shop.config.MIN_ORDER_VALUE || 0) => {
  let checkQuotationRequest = await shop.cart.getExtra( "is_quotation_request" )
  console.log("checkMinCartValue", value, shop.cart.sum, shop.cart.data.extras, checkQuotationRequest)
  if (shop.cart.sum < value && shop.cart.data && checkQuotationRequest && checkQuotationRequest !== true) {
    shop.toast(`Sie haben den Mindestbestellwert (${value} EUR) noch nicht erreicht`)
    return false
  }
  return true
}

export {checkCartSize, checkMinCartValue}



// WEBPACK FOOTER //
// ./src/pages/checkout/check.js